import { KeyboardEvent } from 'react'
import { Color } from 'styles/types'

import Box from 'components/shared/Box'
import Icon from 'components/shared/Icon'
import Text from 'components/shared/Text'
import { ExpandBox, ExpandButton } from './styles'
import { ResponsiveSpace } from 'styles/spacing'

interface ExpandableProps {
    title?: string
    icon?: React.ReactNode
    iconTitle?: React.ReactNode
    color: Color
    iconTitleColor?: Color
    children: React.ReactNode
    maxHeight?: number | [number, number]
    isBoxOpen: boolean
    setIsBoxOpen: (isOpen: boolean) => void
    testIdPrefix?: string
    marginTop?: ResponsiveSpace
}
const ExpandableBox = ({
    title,
    icon,
    iconTitle,
    color,
    iconTitleColor,
    children,
    maxHeight = 1000,
    isBoxOpen,
    setIsBoxOpen,
    testIdPrefix,
    marginTop,
}: ExpandableProps) => {
    const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) =>
        event.key === 'Enter' && setIsBoxOpen(!isBoxOpen)

    return (
        <Box isFullWidth>
            <ExpandButton
                gap={[8, 12]}
                direction="row"
                onClick={() => setIsBoxOpen(!isBoxOpen)}
                onKeyDown={handleKeyDown}
                isFullWidth
                align="center"
                justify={icon ? 'space-between' : 'flex-start'}
                data-testid={
                    testIdPrefix
                        ? `${testIdPrefix}-${isBoxOpen ? 'hide' : 'show'}`
                        : undefined
                }
                tabIndex={0}
            >
                {!!icon && (
                    <Box gap={16} direction="row">
                        {icon}
                        {!!iconTitle && (
                            <Text variant="heading4" color={iconTitleColor}>
                                {iconTitle}
                            </Text>
                        )}
                    </Box>
                )}
                {!!title && (
                    <Text variant="bodyStrong" color={color}>
                        {title}
                    </Text>
                )}
                <Icon
                    variant="chevron"
                    color={color}
                    rotation={isBoxOpen ? 180 : 0}
                />
            </ExpandButton>
            <ExpandBox isOpened={isBoxOpen} isFullWidth maxHeight={maxHeight}>
                <Box mt={marginTop ?? 24} isFullWidth>
                    {children}
                </Box>
            </ExpandBox>
        </Box>
    )
}

export default ExpandableBox
